import React, { useCallback, useState } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import ConfirmationModal from './ConfirmationModal';

// STYLES
import styles from './formModal.module.scss';

// MAIN COMPONENT
const FormModal = ({
  initialValues,
  args: {
    onFetch,
    onResponse,
    ...args
  } = {},
  fields,
  vertical,
  submitButton = {},
  ...props
}) => {

  // STATE
  const [ isSubmitting, setSubmitting ] = useState(false);

  // CALLBACKS
  const handleFetch = useCallback(
    () => {
      doCallback(onFetch);
      setSubmitting(true);
    },
    [onFetch, setSubmitting]
  )
  const handleResponse = useCallback(
    response => {
      doCallback(onResponse, response);
      setSubmitting(false);
    },
    [onResponse, setSubmitting]
  )

  // RENDER
  return (
    <ConfirmationModal
      className={clsx(
        styles.modal,
        vertical && styles.vertical
      )}
      form={{
        initialValues,
        onFetch: handleFetch,
        onResponse: handleResponse,
        ...args
      }}
      body={(
        <Form.Body
          className={clsx(
            styles.body,
            vertical && styles.vertical
          )}
          vertical={vertical}
        >{fields}</Form.Body>
      )}
      continueButton={{
        type: 'submit',
        ...submitButton,
        icon: isSubmitting ? {
          use: 'loader',
          className: 'spin'
        } : submitButton?.icon,
        disabled: isSubmitting
      }}
      {...props}
    />
  )
}

// EXPORT
export default FormModal;
